<td>
  <div class="runner">
    <div class="name">
      <!--      <mat-icon>{{-->
      <!--        isAsianHandicap && rowUpdated() ? "sync" : "equalizer"-->
      <!--      }}</mat-icon>-->
      <mat-icon style="cursor: pointer" (click)="openGraphWindow()">equalizer</mat-icon>
      <span>{{ data?.runnerName }}</span>
      @if (isAsianHandicap) {
        <b>&nbsp;{{ data?.handicapLabel }}</b>
      }
    </div>
    @if (!isAsianHandicap) {
      <div class="pnl">
        @let runnerNetEffect = runnerNetEffect$ | async;
        @let runnerPNetEffect = runnerPNetEffect$ | async;
        @if (isLineMarket && (runnerNetEffect || runnerPNetEffect)) {
          <span>Max Exposure:&nbsp;</span>
        }
        @if (!isNil(runnerNetEffect)) {
          @if (typeof runnerNetEffect === "object") {
            @let profit = runnerNetEffect?.profit;
            @let loss = runnerNetEffect?.loss;
            <span>
              <b
                [ngClass]="{
                  'pnl-green': profit >= 0,
                  'pnl-red': profit < 0,
                }"
                >{{ profit | number: "1.2-2" }}</b
              >,&nbsp;
              <b
                [ngClass]="{
                  'pnl-green': loss >= 0,
                  'pnl-red': loss < 0,
                }"
                >{{ loss | number: "1.2-2" }}</b
              >
            </span>
          } @else {
            <b
              [ngClass]="{
                'pnl-green': runnerNetEffect >= 0,
                'pnl-red': runnerNetEffect < 0,
              }"
              >{{ runnerNetEffect | number: "1.2-2" }}</b
            >
          }
        }

        @if (!isNil(runnerPNetEffect)) {
          @if (typeof runnerPNetEffect === "object") {
            @let profit = runnerPNetEffect?.profit;
            @let loss = runnerPNetEffect?.loss;
            <span>
              &nbsp;&#xbb;
              <b
                [ngClass]="{
                  'pnl-green': profit >= 0,
                  'pnl-red': profit < 0,
                }"
                >&nbsp;{{ profit | number: "1.2-2" }}</b
              >,&nbsp;
              <b
                [ngClass]="{
                  'pnl-green': loss >= 0,
                  'pnl-red': loss < 0,
                }"
                >{{ loss | number: "1.2-2" }}</b
              >
            </span>
          } @else {
            <b
              [ngClass]="{
                'pnl-green': runnerPNetEffect >= 0,
                'pnl-red': runnerPNetEffect < 0,
              }"
              >&nbsp;&#xbb;&nbsp;{{ runnerPNetEffect | number: "1.2-2" }}</b
            >
          }
        }
      </div>
    }
  </div>
</td>
@if (market?.description?.bettingType === "LINE" && (pnlCalculator.hasPlacedBets(market?.marketId) | async)) {
  <td>
    <button mat-button (click)="pnlCalculator.showLinePnl(market?.marketId)">P&L</button>
  </td>
}
@let exchangeRate = exRateService.exRate$ | async;
@let exRate = exchangeRate?.RATE ?? 1;
<td class="odd-cell">
  <a
    (click)="
      handleSelect({
        PRICE: row?.back3?.price,
        SIZE: row?.back3?.size,
        SIDE: 'BACK',
      })
    "
    class="value-cell"
    [ngClass]="{
      changed: priceChangeFlash && row?.back3?.changed,
      'bg-back': config?.coloredBacks?.includes(3),
    }">
    <span class="value-price">
      {{ row?.back3?.price || "-" }}
    </span>
    <span class="value-size">
      {{ row.back3.size ? (row.back3.size * exRate | number: "1.0-0") : "-" }}
    </span>
  </a>
</td>
<td class="odd-cell">
  <a
    (click)="
      handleSelect({
        PRICE: row?.back2?.price,
        SIZE: row?.back2?.size,
        SIDE: 'BACK',
      })
    "
    class="value-cell"
    [ngClass]="{
      changed: priceChangeFlash && row?.back2?.changed,
      'bg-back': config?.coloredBacks?.includes(2),
    }">
    <span class="value-price">
      {{ row?.back2?.price || "-" }}
    </span>
    <span class="value-size">
      {{ row.back2.size ? (row.back2.size * exRate | number: "1.0-0") : "-" }}
    </span>
  </a>
</td>
<td class="odd-cell">
  <a
    (click)="
      handleSelect({
        PRICE: row?.back1?.price,
        SIZE: row?.back1?.size,
        SIDE: 'BACK',
      })
    "
    class="value-cell"
    [ngClass]="{
      changed: priceChangeFlash && row?.back1?.changed,
      'bg-back': config?.coloredBacks?.includes(1),
    }">
    <span class="value-price">
      {{ row?.back1?.price || "-" }}
    </span>
    <span class="value-size">
      {{ row.back1.size ? (row.back1.size * exRate | number: "1.0-0") : "-" }}
    </span>
  </a>
</td>
@if (wlConfigService.showLayBet(market)) {
  <td class="odd-cell">
    <a
      (click)="
        handleSelect({
          PRICE: row?.lay1?.price,
          SIZE: row?.lay1?.size,
          SIDE: 'LAY',
        })
      "
      class="value-cell"
      [ngClass]="{
        changed: priceChangeFlash && row?.lay1?.changed,
        'bg-lay': config?.coloredLays?.includes(1),
      }">
      <span class="value-price">
        {{ row?.lay1?.price || "-" }}
      </span>
      <span class="value-size">
        {{ row.lay1.size ? (row.lay1.size * exRate | number: "1.0-0") : "-" }}
      </span>
    </a>
  </td>
  <td class="odd-cell">
    <a
      (click)="
        handleSelect({
          PRICE: row?.lay2?.price,
          SIZE: row?.lay2?.size,
          SIDE: 'LAY',
        })
      "
      class="value-cell"
      [ngClass]="{
        changed: priceChangeFlash && row?.lay2?.changed,
        'bg-lay': config?.coloredLays?.includes(2),
      }">
      <span class="value-price">
        {{ row?.lay2?.price || "-" }}
      </span>
      <span class="value-size">
        {{ row.lay2.size ? (row.lay2.size * exRate | number: "1.0-0") : "-" }}
      </span>
    </a>
  </td>
  <td class="odd-cell">
    <a
      (click)="
        handleSelect({
          PRICE: row?.lay3?.price,
          SIZE: row?.lay3?.size,
          SIDE: 'LAY',
        })
      "
      class="value-cell"
      [ngClass]="{
        changed: priceChangeFlash && row?.lay3?.changed,
        'bg-lay': config?.coloredLays?.includes(3),
      }">
      <span class="value-price">
        {{ row?.lay3?.price || "-" }}
      </span>
      <span class="value-size">
        {{ row.lay3.size ? (row.lay3.size * exRate | number: "1.0-0") : "-" }}
      </span>
    </a>
  </td>
}
